import styled from 'styled-components';
import { Button } from 'antd';
import { ReactComponent as GooglePlusIcon } from '../../../assets/icons/google-plus.svg';


export const StyledGoogleSignInButton = styled(Button)`
  && {
    position: relative;
    padding: 10px 22px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-family: Inter;

    &:not(:disabled) {
      background-color: ${({ theme }) => theme.color.tertiary.green};
      color: ${({ theme }) => theme.color.greyscale.white};

      &:hover {
        color: ${({ theme }) => theme.color.greyscale.white};
        border: none;
        box-shadow: none;
        filter: brightness(115%);
      }

      &:active {
        color: ${({ theme }) => theme.color.greyscale.white};
      }
    }
  }
`;

export const StyledGooglePlusIcon = styled(GooglePlusIcon)`
  position: absolute;
  left: 22px;
`;
